export default __webpack_public_path__ + "static/media/digital-management-tools-integration.d9ba708e.svg";